jQuery(document).ready(function($) {
    'use strict';

    var windowWidth = $(window).outerWidth();

    function isOnScreen(elem) {
        // if the element doesn't exist, abort
        if( elem.length == 0 ) {
            return;
        }
        var $window = jQuery(window)
        var viewport_top = $window.scrollTop()
        var viewport_height = $window.height()
        var viewport_bottom = viewport_top + viewport_height
        var $elem = jQuery(elem)
        var top = $elem.offset().top
        var height = $elem.height()
        var bottom = top + height

        return (top >= viewport_top && top < viewport_bottom) ||
            (bottom > viewport_top && bottom <= viewport_bottom) ||
            (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    }

    if( $('.action-bar').length ) {

        $( ".search_wrp input" ).focus(function() {
            $('.action-bar.active').addClass('inactive');
        });
        $( ".search_wrp input" ).blur(function() {
            $('.action-bar.active').removeClass('inactive');
        });

        window.addEventListener('scroll', function(e) {
            if( $('html').hasClass('flyout--open') ) {
                return;
            }
            if( isOnScreen( $( '.total-price' ) ) ) {
                $('.kundo-chat-widget__start-button').addClass('standard');
                if( isOnScreen( $( '.action-bar-scroll' ) ) ) {
                    $('.action-bar').removeClass('active');
                }
                if(windowWidth < 768) {
                    $('.add-to-cart span').text('Lägg i varukorg');
                }
            } else {
                $('.action-bar').addClass('active').removeClass('inactive');
                $('.kundo-chat-widget__start-button').removeClass('standard');
                if(windowWidth < 768) {
                    $('.add-to-cart span').text('Köp');
                }
            }
        });

    }


});
